<template>
  <div id="draggable1" v-if="skuId">
    <!-- 如果碰到滑动问题，1.1 请检查这里是否属于同一点。 -->
    <!-- 悬浮的HTML -->
    <div
      class="weightCard"
      id="moveDiv1"
      @mousedown="down"
      @touchstart="down"
      @mousemove="move"
      @touchmove.prevent="move"
      @mouseup="end"
      @touchend="end"
    >
      <Spin fix v-if="loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      <div v-if="!loading">
        <img :src="cover" style="object-fit:cover;width: 200px;height: 200px"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "picModal",
    props: {
      skuId: Number
    },
    data() {
      return {
        loading: true,
        cover: "",
        flags: false,
        position: {x: 0, y: 0}, // 鼠标的横纵坐标
        pageX: "", // 页面可视区域的宽
        pagey: "", // 页面可视区域的高
        nx: "",
        ny: "",
        dx: "",
        dy: "",
        xPum: "",
        yPum: "",
      };
    },
    methods: {
      showCover(skuId) {
        this.loading = true;
        this.skuId = skuId;
        if (this.$store.state.allSkus) {
          this.cover = this.$store.state.allSkus[skuId];
          this.loading = false;
        }
      },
      // 实现移动端拖拽
      down() {
        this.flags = true; //是否开启拖拽
        let touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.position.x = touch.clientX;
        this.position.y = touch.clientY;
        this.dx = moveDiv1.offsetLeft;
        this.dy = moveDiv1.offsetTop;
      },
      move() {
        if (this.flags) {
          let touch;
          if (event.touches) {
            touch = event.touches[0];
          } else {
            touch = event;
          }
          this.nx = touch.clientX - this.position.x;
          this.ny = touch.clientY - this.position.y;

          this.yPum = this.dy + this.ny;
          if (this.dx + this.nx <= 0) {
            this.xPum = 0;
          } else if (this.dx + this.nx >= this.pageX - 200) {
            this.xPum = this.pageX - 200;
          } else {
            this.xPum = this.dx + this.nx;
          }
          if (this.dy + this.ny <= 0) {
            this.yPum = 0;
          } else if (this.dy + this.ny >= this.pagey - 200) {
            this.yPum = this.pagey - 200;
          } else {
            this.yPum = this.dy + this.ny;
          }
          moveDiv1.style.left = this.xPum + "px";
          moveDiv1.style.top = this.yPum + "px";
          //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
          document.addEventListener(
            "touchmove",
            function () {
              event.preventDefault();
            },
            false
          );
        }
      },
      //鼠标释放时候的函数
      end() {
        this.flags = false;
      }
    },
    mounted() {
      this.pageX = document.body.offsetWidth;
      this.pagey = document.body.offsetHeight;
    },
  }
</script>

<style scoped>
  .weightCard {
    /* 如果页面报错 [Intervention] Unable to preventDefault inside passive event listener due to target being treated as passive. See <URL>；   请添加样式 touch-action: none; */
    touch-action: none;
    height: 200px;
    width: 200px;
    /* 如果碰到滑动问题，1.3 请检查 z-index。z-index需比web大一级*/
    z-index: 999;
    position: fixed;
    bottom: 20px;
    right: 0;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.75);
  }
</style>



// WEBPACK FOOTER //
// src/components/picModal/picModal.vue